import React from "react";
import { Skeleton, Box, Divider } from "@mui/material";

const SkeletonRow = ({ width = "60%" }) => (
  <Box display="flex" justifyContent="space-between" alignItems="center" py={1}>
    <Skeleton variant="text" width="30%" height={20} />
    <Skeleton variant="text" width={width} height={20} />
  </Box>
);

const ChargeLoader = () => {
  return (
    <Box p={2} className="drawer-content">
      {/* Simulate multiple sections with titles and content rows */}
      {[...Array(2)].map((_, index) => (
        <Box key={index} mb={4}>
          <Skeleton variant="text" width="40%" height={30} />
          <Box mt={2}>
            {[...Array(9)].map((_, rowIndex) => (
              <SkeletonRow key={rowIndex} width={`${60}%`} />
            ))}
          </Box>
          <Divider sx={{ my: 2 }} />
        </Box>
      ))}
    </Box>
  );
};

export default ChargeLoader;
